import {Component,  Inject,  OnInit } from '@angular/core';
import { Utilities } from '../../core/models/utilities';
import { BankPortalService } from '../../web-api-client';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.css']
})
export class TableComponent implements OnInit {
public  transactionData:any;
//for ag-grid
gridApi: any;
gridColumnApi: any;
columnDefs : any;
rowCache : any;

//for filter
status = [
  {value: 0, option: 'ALL'},
  {value: 1, option: 'SUCCESS'},
  {value: 2, option: 'FAILED'},
]

constructor(@Inject(String) private _bankPortalService :BankPortalService){

}

ngOnInit(){
      this.getTransactionDashBoardData();
      this.columnDefs = [
        {headerName: 'S.N.',  valueGetter: 'node.rowIndex+1',  width: 130},
        {headerName: 'Transaction Date', field: 'createdDate',  width: 250, resizable: true},
        { headerName: 'Merchant Name', field: 'merchantName', width: 250},
        { headerName: 'Address', field: 'address', width: 130},
        { headerName: 'Terminal ID', field: 'terminalId', width: 130, cellRenderer : this.termId},
        { headerName: 'MerchantId', field: 'merchantId', width: 130, cellRenderer : this.merchantId},
        { headerName: 'Card Number', field: 'cardNumber', width: 130},
        { headerName: 'Contact', field: 'contactNumber', width: 130, cellRenderer : this.contactNo},
        { headerName: 'Status', field: 'status', width: 130,},
        { headerName: 'Total Amount', field: 'amount', width: 130},
        { headerName: 'Network Type', field: 'networkType', width: 130},
    ];
}

getTransactionDashBoardData(){
    this._bankPortalService.bankPortal_GetPOSTerminalTransactionDetails().subscribe(res=>{
      this.rowCache = [...res];
     this.transactionData = res;
    //  console.table(this.transactionData);
    //  console.log(this.transactionData);
    },
    _err=>{

    });
  }

  onBtnExport() {
    this.gridApi.exportDataAsCsv();
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onSearchChanged(value: string) {
    this.transactionData = this.rowCache.filter(r => Utilities.searchArray(value, false,  r.merchant, r.idMerchant, r.idTerminal, r.item, r.address, r.contactPerson, r.serialKey, r.statusName, r.requestName));
  }

  onModelUpdated() {
    setTimeout(() => { this.gridColumnApi.autoSizeAllColumns() });
  }


  public merchantId(params) {
    var temp = params.data.merchantId;
    var newtemp = temp.substring(0, temp.length - 1);
    return newtemp;
}
public termId(params) {
    var temp = params.data.terminalId;
    var newtemp = temp.substring(0, temp.length - 1);
    return newtemp;
}
public contactNo(params) {
  var temp = params.data.contactNumber;
  var newtemp = temp.substring(0, temp.length - 1);
  return newtemp;
}

  onStatusFilter(e : any){
    console.log(e.option);
    if(e.value == 0) return this.transactionData = this.rowCache;

    let temp = this.rowCache;

    return this.transactionData = temp.filter(x => x.status == e.option);

  }

}
